import { InternalAxiosRequestConfig } from "axios";
import { ResourceView } from "../../types/language";
import { RequestDTO } from "../../types/requestDTO";
import request from "../base-service";

const BASE_URL = '/v1';

export const resourceApi = {
    // Lấy danh sách tài nguyên có phân trang (dynamic pivot theo ngôn ngữ)
    pager: (requestDTO: RequestDTO) => {
        return request.post(`${BASE_URL}/resource/pager`, requestDTO, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Lấy danh sách tài nguyên theo ngôn ngữ
    list: (requestDTO: RequestDTO) => {
        return request.post(`${BASE_URL}/resource/list`, requestDTO, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Tạo mới tài nguyên
    create: (data: ResourceView) => {
        return request.post(`${BASE_URL}/resource`, data, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Cập nhật tài nguyên
    update: (id: string | number, data: ResourceView) => {
        return request.put(`${BASE_URL}/resource/${id}`, data, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Upsert tài nguyên (thêm mới hoặc cập nhật theo ResourceName + LanguageAlias)
    upsert: (data: ResourceView) => {
        return request.post(`${BASE_URL}/resource/upsert`, data, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Xóa tài nguyên
    delete: (id: string | number) => {
        return request.delete(`${BASE_URL}/resource/${id}`, {
            authorization: true,
        } as InternalAxiosRequestConfig);
    },
    // Lấy locale (key-value) cho 1 ngôn ngữ
    getLocale: (languageId: number) => {
        return request.get(`${BASE_URL}/locale/${languageId}`);
    },
}
